import type { FileDetails } from '@common/types/files';
import axiosInstance from './axiosInstance';

export async function uploadFile(
    value: File,
    lawFirmId: number | string,
    fileType: string,
    typeOfID?: string,
): Promise<FileDetails> {
    const formData = new FormData();
    formData.append('File', value);
    const response = await axiosInstance.post<FileDetails>(
        `api/v1/files/${lawFirmId}/${fileType}`,
        formData,
        { params: { typeOfID } },
    );
    return response.data;
}

export async function deleteFile(fileId: string) {
    return axiosInstance.delete(`api/v1/files/${fileId}`);
}

export async function getFileDetails(fileId: string) {
    return axiosInstance.get<FileDetails>(`api/v1/files/${fileId}/fileDetails`);
}

export async function downloadFile(fileId: string) {
    return axiosInstance.get<Blob>(`api/v1/files/${fileId}`, { responseType: 'blob' });
}

export function getDownloadLink(fileId?: string) {
    return fileId ? `${import.meta.env.VITE_APP_API_URL}/api/v1/files/${fileId}` : '';
}
